import tldjs from 'tldjs';

const { getDomain } = tldjs;

const REGISTRATION_TYPES = {
  byPhone: 'byPhone',
  byUsername: 'byUsername',
};

const {
  VITE_REACT_APP_SERVER_URL,
  VITE_REACT_APP_STATIC_URL,
  VITE_REACT_APP_DICTIONARY_URL,
  VITE_REACT_APP_SOCKET_URL,
  VITE_REACT_APP_ONLY_SPORT,
} = import.meta.env;

const searchParams = new URLSearchParams(location.search);

// Working for multiple tlds like example.co.ke
const domain = getDomain(location.hostname) || 'gtestbet.com';

function getServerUrls() {
  const domainUrls = {
    staticUrl: `https://st.${domain}`,
    dictionaryUrl: `https://ts.${domain}`,
    socketUrl: `https://lv.${domain}`,
  };

  if (VITE_REACT_APP_ONLY_SPORT) {
    domainUrls.serverUrl =
      searchParams.get('serverUrl') || `https://api.${domain}`;

    return domainUrls;
  } else if (import.meta.env.PROD) {
    domainUrls.serverUrl = `https://api.${domain}`;

    return domainUrls;
  }

  return {
    serverUrl: VITE_REACT_APP_SERVER_URL,
    staticUrl: VITE_REACT_APP_STATIC_URL,
    dictionaryUrl: VITE_REACT_APP_DICTIONARY_URL,
    socketUrl: VITE_REACT_APP_SOCKET_URL,
  };
}

const SERVER_URLS = getServerUrls();

export const LINK_PATTERN = new RegExp(
  '^(https?:\\/\\/)?' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$',
  'i',
);

const CURRENCY_SYMBOLS = {
  USD: '$', // US Dollar
  EUR: '€', // Euro
  CRC: '₡', // Costa Rican Colón
  GBP: '£', // British Pound Sterling
  ILS: '₪', // Israeli New Sheqel
  INR: '₹', // Indian Rupee
  JPY: '¥', // Japanese Yen
  KRW: '₩', // South Korean Won
  NGN: '₦', // Nigerian Naira
  PHP: '₱', // Philippine Peso
  PLN: 'zł', // Polish Zloty
  PYG: '₲', // Paraguayan Guarani
  THB: '฿', // Thai Baht
  UAH: '₴', // Ukrainian Hryvnia
  VND: '₫', // Vietnamese Dong
};

export const CONSTANTS = {
  domain,
  REGISTRATION_TYPES,
  SERVER_URLS,
  LINK_PATTERN,
  CURRENCY_SYMBOLS,
};
